import { Link } from "react-router-dom";
import { ArrowRight, Scale } from "lucide-react";
import { CHARGES } from "@/data/guides";

export default function Charges() {
  return (
    <div className="grain-bg min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <span className="font-mono text-xs uppercase tracking-[0.18em] text-terracotta">Charge guides</span>
        <h1 data-testid="charges-title" className="mt-3 font-serif text-4xl sm:text-5xl lg:text-6xl font-semibold text-forest-900 max-w-3xl">
          Understand the charge you're facing
        </h1>
        <p className="mt-4 text-ink-700 leading-relaxed max-w-2xl">
          What prosecutors must prove, typical penalties, common defenses and what to do next — with state-by-state
          penalty details for all 50 states and D.C.
        </p>
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {CHARGES.map((c) => (
            <Link key={c.slug} to={`/charges/${c.slug}`} data-testid={`charge-link-${c.slug}`}
              className="group rounded-2xl border border-parchment-200 bg-white p-6 hover:border-forest-800 transition-colors">
              <Scale className="h-5 w-5 text-terracotta" />
              <h2 className="mt-3 font-serif text-2xl font-semibold text-forest-900">{c.name}</h2>
              <p className="mt-1.5 text-sm text-ink-600">{c.blurb}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-terracotta">
                Read the guide <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
